<app-header label="Masters"></app-header>
<div class="min-h-screen font-sans text-gray-600 flex flex-col gap-4 w-full p-4">
  <app-search-input #searchbar></app-search-input>
  <div class="w-full mx-auto pb-12">
    <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 gap-6">
      @for (group of master_groups; track group.title) {
      <div class="group bg-white rounded-2xl p-6 border border-transparent hover:border-primary/10 shadow-[0_2px_8px_rgba(0,0,0,0.04)] hover:shadow-lg transition-all duration-300 ease-in-out">
        <div class="flex items-center gap-4 mb-6">
          <div class="p-3 flex justify-center items-center rounded-full bg-gray-50 text-gray-400 group-hover:text-primary group-hover:bg-primary/5 transition-colors duration-300"><i class='bx text-xl {{group.icon}}'></i> </div>
          <span class="text-lg font-bold text-gray-900">{{ group.title }}</span>
        </div>
        <div class="flex flex-col space-y-1 cursor-pointer">
          @for (link of group.links; track link.label) {
          <span [routerLink]="[link.link]" [queryParams]="link.queryParams || null"  routerLinkActive="router-link-active" class="block px-2 py-2 text-sm font-medium text-gray-500 rounded-lg hover:text-primary hover:bg-gray-50 transition-colors duration-200">{{ link.label }}</span>
          }
        </div>
      </div>
      }
    </div>
  </div>
</div>